<template>
  <div class="mt-2">
    <input
      type="checkbox"
      :id="'checkEnrolmentPeriod' + type"
      v-model="enrolmentPeriod.IsActive"
      style="cursor: pointer"
      @change="toggleEnrolmentPeriod"
    />
    <label :for="'checkEnrolmentPeriod' + type" style="cursor: pointer"
      >Open Enrolment Period</label
    >

    <form @submit.prevent="save" v-if="enrolmentPeriod.IsActive">
      <div class="row align-items-center">
        <div class="col-md-1 pr-0" style="max-width: fit-content">From</div>
        <div class="col-md-3">
          <input
            type="date"
            class="form-control"
            required
            v-model="enrolmentPeriod.FromDateStr"
            :disabled="enrolmentPeriod.Id && !isEdit"
          />
        </div>
        <div class="col-md-1 pr-0" style="max-width: fit-content">To</div>
        <div class="col-md-3">
          <input
            type="date"
            class="form-control"
            required
            v-model="enrolmentPeriod.ToDateStr"
            :disabled="enrolmentPeriod.Id && !isEdit"
            :min="enrolmentPeriod.FromDateStr"
          />
        </div>
        <div class="col-md-4">
          <button
            type="button"
            class="btn btn-primary"
            @click="isEdit = true"
            v-if="enrolmentPeriod.Id && !isEdit"
          >
            <i class="fa fa-edit mr-1"></i>Edit
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            v-if="!enrolmentPeriod.Id || isEdit"
          >
            <i class="fa fa-save mr-1"></i>Save
          </button>
          <button
            type="button"
            class="btn btn-danger"
            @click="cancel"
            v-if="enrolmentPeriod.Id && isEdit"
          >
            <i class="fa fa-close mr-1"></i>Cancel
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import API from "../../http-common.js";
export default {
  props: ["type"],
  data() {
    return {
      enrolmentPeriod: {
        Id: null,
        FromDateStr: "",
        ToDateStr: "",
        IsActive: false,
      },
      isEdit: false,
    };
  },

  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
  },

  methods: {
    getEnrolmentPeriod() {
      let param = {
        Token: this.token,
        Type: this.type,
      };
      this.$store.state.isLoading = true;
      API.getEnrolmentPeriod(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            if (response.data.record)
              this.enrolmentPeriod = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },

    saveEnrolmentPeriod(mode) {
      let param = {
        Token: this.token,
        Id: this.enrolmentPeriod.Id,
        FromDateInput: this.enrolmentPeriod.FromDateStr,
        ToDateInput: this.enrolmentPeriod.ToDateStr,
        IsActive: this.enrolmentPeriod.IsActive,
        Type: this.type,
      };
      this.$store.state.isLoading = true;
      API.saveEnrolmentPeriod(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            if (mode == "enable") {
              this.$swal("Enrolment period enabled successfully!", {
                icon: "success",
              });
            } else if (mode == "disable") {
              this.$swal("Enrolment period disabled successfully!", {
                icon: "success",
              });
            } else if (mode == "save") {
              this.$swal(response.data.message, { icon: "success" });
            }
            this.isEdit = false;
            this.getEnrolmentPeriod();
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },

    cancel() {
      this.isEdit = false;
      this.getEnrolmentPeriod();
    },
    save() {
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to save the record?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willSave) => {
        if (willSave) {
          this.saveEnrolmentPeriod("save");
        } else {
          this.cancel();
        }
      });
    },
    toggleEnrolmentPeriod($event) {
      if (this.enrolmentPeriod.Id) {
        if ($event.target.checked) {
          this.saveEnrolmentPeriod("enable");
        } else {
          this.$swal({
            title: "Are you sure?",
            text: "Are you sure you want to disable the enrolment period?",
            icon: "info",
            buttons: true,
            dangerMode: false,
          }).then((willSave) => {
            if (willSave) {
              this.saveEnrolmentPeriod("disable");
            } else {
              this.cancel();
            }
          });
        }
      }
    },
  },

  created() {
    this.getEnrolmentPeriod();
  },
};
</script>

<style scoped>
[type="checkbox"] {
  vertical-align: middle;
}
</style>


// WEBPACK FOOTER //
// src/components/System/EnrolmentPeriod.vue